export default __webpack_public_path__ + "static/media/photo10.13b81926.jpg";